export default __webpack_public_path__ + "static/media/employer_license_fee.d998d486.svg";